module.exports = __webpack_public_path__ + "static/media/mobile.e8eb77f8.svg";